import React from "react";
import { PriceChartIcon, Spinner } from "../../../IconTheme";

const data = [
	{
		status: "claimed",
	},
	{
		status: "locked",
	},
	{
		status: "active",
	},
	{
		status: "active",
	},
];

const VestingInformation = () => {
	return (
		<div className="chart-card pb-1">
			<div className="price-chart-header d-flex flex-wrap align-items-center">
				<PriceChartIcon />
				<h5 className="m-0 mt-1 ps-2">My Vesting Information</h5>
			</div>
			<ul className="vesting-information-list py-3">
				<li>
					<span>Round:</span>
					<span style={{ background: "rgba(#FFAA35, .8)" }}>Staking</span>
				</li>
				<li>
					<span>Amount Staked:</span>
					<span>82 ANT</span>
				</li>
				<li>
					<span>Round Starts At:</span>
					<span>Mar 23, 2022 21:45</span>
				</li>
				<li>
					<span>Amount Participated:</span>
					<span>82ANT</span>
				</li>
				<li>
					<span>Round Ends At:</span>
					<span>Mar 22, 2022 09:10</span>
				</li>
				<li>
					<span>Tokens Bought:</span>
					<span>
						82 WTR <small>($4.41)</small>
					</span>
				</li>
				<li>
					<span>Allocation Granted:</span>
					<span>
						82 WTR <small>($4.41)</small>
					</span>
				</li>
				<li>
					<span>Tokens Unlock At:</span>
					<span>Mar 21, 2022 15:38</span>
				</li>
			</ul>
			<div className="price-chart-header d-flex flex-wrap align-items-center">
				<PriceChartIcon />
				<h5 className="m-0 mt-1 ps-2">My Vesting Allocation</h5>
			</div>
			<div className="table-responsive">
				<table className="table __table">
					<thead>
						<tr>
							<th>
								<span className="me-1">Order</span> <Spinner />
							</th>
							<th>
								<span className="me-1">Amount</span> <Spinner />
							</th>
							<th>
								<span className="me-1">Unlooked</span> <Spinner />
							</th>
							<th>
								<span className="me-1">Portion Unlock At</span>{" "}
								<Spinner />
							</th>
							<th>
								<span className="me-1 ms-md-5 ms-lg-4 ms-xl-5">
									Status
								</span>{" "}
								<Spinner />
							</th>
						</tr>
					</thead>
					<tbody>
						{data?.map(({ status }, i) => (
							<tr>
								<td>
									<span className="td">01</span>
								</td>
								<td>
									<span className="td">
										82 WTR <small>($4.41)</small>
									</span>
								</td>
								<td>
									<span className="td">28.14%</span>
								</td>
								<td>
									<span className="td">Mar 22, 2022 09:10</span>
								</td>
								<td className="text-md-end">
									<button
										className={`cmn-btn badge--btn ${
											status === "locked"
												? "bg-white border-white text-dark"
												: ""
										}`}
										disabled={status === "claimed"}
									>
										{status === "claimed"
											? "Claimed"
											: status === "active"
											? "Claim"
											: "Locked"}
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default VestingInformation;
